import React, { Fragment } from 'react';
import '../about/css/team.css';
import bg1 from '../../images/banner/b5.jpg';
import {Link } from'react-router-dom';
import { FaFacebookSquare ,FaInstagram ,FaTwitter} from 'react-icons/fa';

const Team = () => {
    return (
        <Fragment>
            <div className="Total_div">
                <h2>OUR TEAM</h2>
                <div className="Total_Team">
                <div className="Our_Team" data-aos="fade-up"  data-aos-duration="1000" >
                        <div className="Team">
                            <img src={bg1} className="Teamimg" alt='Harshitha developers and constructions Team' />
                            <div className="Team_Overlay">

                            </div>
                            <Link to='/projects' className='btn'>view more</Link>
                        </div>
                        <div className="TeamText">
                                <h2>Harshitha </h2>
                                <p>Lorem ipsum dolor </p>
                              <div className="Team_Social">
                              <i ><FaFacebookSquare /></i>
                              <i ><FaInstagram /></i>
                              <i ><FaTwitter /></i>     
                              </div>      
                        </div>
                    </div>
                    <div className="Our_Team" data-aos="fade-up"  data-aos-duration="1000" >
                        <div className="Team">
                            <img src={bg1} className="Teamimg" alt='Harshitha developers and constructions Team' />
                            <div className="Team_Overlay">

                            </div>
                            <Link to='/projects' className='btn'>view more</Link>
                           
                        </div>
                        <div className="TeamText">
                                <h2>Harshitha </h2>
                                <p>Lorem ipsum dolor </p>
                              <div className="Team_Social">
                              <i ><FaFacebookSquare /></i>
                              <i ><FaInstagram /></i>
                              <i ><FaTwitter /></i>     
                              </div>      
                        </div>
                    </div>
                    <div className="Our_Team" data-aos="fade-up"  data-aos-duration="1000" >
                        <div className="Team">
                            <img src={bg1} className="Teamimg" alt='Harshitha developers and constructions Team' />
                            <div className="Team_Overlay">

                            </div>
                            <Link to='/projects' className='btn'>view more</Link>
                           
                        </div>
                        <div className="TeamText">
                                <h2>Harshitha </h2>
                                <p>Lorem ipsum dolor </p>
                              <div className="Team_Social">
                              <i ><FaFacebookSquare /></i>
                              <i ><FaInstagram /></i>
                              <i ><FaTwitter /></i>     
                              </div>      
                        </div>
                    </div>
            </div>
            </div>
        </Fragment>
        
    )
}

export default Team;